import * as AC from './actionTypes';

export function updateRegisterData(data) {
  return {
    type: AC.SET_BASIC_REGISTER_DATA,
    data
  };
}

export function updateRegisterFields(hash) {
  return {
    type: AC.UPDATE_REGISTER_FIELDS,
    hash
  };
}

export function setUserLogged(customer) {
  return {
    type: AC.SET_USER_LOGGED,
    customer
  };
}

export function setUserLogout() {
  return {
    type: AC.SET_USER_LOGOUT,
  };
}

export function showSpashScreen() {
  return {
    type: AC.SHOW_SPLASH_SCREEN,
  };
}

export function hideSpashScreen() {
  return {
    type: AC.HIDE_SPLASH_SCREEN,
  };
}

export function resetRegisterFields() {
  return {
    type: AC.RESET_REGISTER_FIELDS,
  };
}

export function resetRegisterErrors() {
  return {
    type: AC.RESET_REGISTER_ERRORS,
  };
}

export function updateCustomerPhone(phone) {
  return {
    type: AC.UPDATE_CUSTOMER_PHONE,
    phone
  };
}

export function updateLoggedCustomerInvoiceData(invoiceData) {
  return {
    type: AC.UPDATE_CUSTOMER_INVOICE_DATA,
    invoiceData
  };
}

export function setServerRespondedToAjax(value) {
  return {
    type: AC.SET_SERVER_RESPONDED_TO_AJAX,
    value
  }
}
